import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { DateFormats } from '@nk/utils-lib';

@Component({
  selector: 'nk-date-range',
  imports: [CommonModule, TranslateModule],
  templateUrl: './date-range.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DateRangeComponent {
  @Input() public dates: { fromDate: Date | null; toDate: Date | null } | undefined = undefined;
  @Input() public dateFormat = DateFormats.ShortFormFullDate;
  /**
   * If `true` will always show a range, even if both values are nulls.
   * If `false` and both values are nulls will show only "unknown"
   */
  @Input() public showUntilNow = false;
  public dateFormats = DateFormats;
}
